import { render, staticRenderFns } from "./SerialNumbersPage.vue?vue&type=template&id=3b01f078"
import script from "./SerialNumbersPage.vue?vue&type=script&lang=js"
export * from "./SerialNumbersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports